import {Toast as ToastPrimitive} from "@base-ui/react/toast";

const toast = ToastPrimitive.createToastManager()
const createToastManager = ToastPrimitive.createToastManager
const useToastManager = ToastPrimitive.useToastManager

function showToast(title: string, description?: string, timeout = 5000, refetch?: () => Promise<unknown>, reset?: () => void, type: "success" | "warn" | "error" | "default" = 'default'): string {
    const id = toast.add({
        title: title,
        description: description,
        type,
        timeout
    });
    if (reset && refetch) {
        refetch().then(() => {
            reset();
        });
    } else if (refetch) {
        refetch().then();
    } else if (reset) {
        setTimeout(() => {
            reset();
        }, timeout);
    }
    return id;

}

export {showToast, toast, createToastManager, useToastManager};
